import publicUnavailabePaths from './publicUnavailabePaths.json';

const baseUnavailablePaths: string[] = [
	'/account-verifications',
	'/custodian-incomplete-sign-up',
	'/potential',
	'/retire-distribution-revocation',
	'/document-uploads',
	'/smart-save*',
	'/unavailable',
	'/cash-back',
	'/cash-back/*',
	'/cashback',
	'/cashback/*',
	'/spend-wise',
	'/balance',
	'/user-profile/settings/changeaddress',
	'/party*',
];

export { publicUnavailabePaths };

export const unavailablePaths = baseUnavailablePaths.concat(publicUnavailabePaths);
